import { render, staticRenderFns } from "./UserNotActivated.vue?vue&type=template&id=0283492e&v-once=true"
import script from "./UserNotActivated.vue?vue&type=script&lang=ts"
export * from "./UserNotActivated.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports